import api, { transformResponse } from "services/api";

export const templatesApi = api
  .enhanceEndpoints({ addTagTypes: ["AiDialerTemplates", "AiDialerCallConfigurations"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchAiDialerTemplates: build.query({
        query: () => "/api/v1/core/ai-dialer-templates/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "AiDialerTemplates", id })),
                { type: "AiDialerTemplates", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'AiDialerTemplates', id: 'LIST' }` is invalidated
              [{ type: "AiDialerTemplates", id: "LIST" }],
      }),
      fetchAiDialerCallConfigs: build.query({
        query: () => "/api/v1/core/ai-dialer-templates/configurations/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "AiDialerCallConfigurations", id })),
                { type: "AiDialerCallConfigurations", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'AiDialerCallConfigurations', id: 'LIST' }` is invalidated
              [{ type: "AiDialerCallConfigurations", id: "LIST" }],
      }),
      validateAiDialerTemplates: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/ai-dialer-templates/${payload.id}/validate/`,
          method: "POST",
          body: payload,
        }),
        transformResponse: (response) => transformResponse(response),
      }),
    }),
  });

export const {
  useFetchAiDialerTemplatesQuery,
  useFetchAiDialerCallConfigsQuery,
  useValidateAiDialerTemplatesMutation,
} = templatesApi;
